import {isString, assign} from 'min-dash';
import {Moddle} from 'moddle';
import {Reader, Writer} from 'moddle-xml';
import {ARCHIMATE_MODEL} from '../metamodel/Concept';
import type {ModdleConfig, ModdleElement, ModdlePackageInput} from 'moddle';
import type {ModdleXmlParseResult, ReaderOptions, WriterOptions} from 'moddle-xml';

/** Опции чтения XML без обязательного `model` (задаётся в ArchimateModdle#fromXML). */
type ArchimateReaderExtra = Omit<ReaderOptions, 'model'>;

/**
 * A subclass of {@link Moddle} with support for import and export of archimate-js XML files.
 *
 * @class ArchimateModdle
 *
 * @extends Moddle
 *
 * @param {Object|Array} packages to use for instantiating the model
 * @param {Object} [options] additional options to pass over
 */
export default class ArchimateModdle extends Moddle {
	constructor(packages: ModdlePackageInput, options?: ModdleConfig) {
		super(packages, options);
	}

	fromXML(
		xmlStr: string,
		typeNameOrOptions?: string | ArchimateReaderExtra,
		options?: ArchimateReaderExtra
	): Promise<ModdleXmlParseResult> {
		let typeName: string = ARCHIMATE_MODEL;
		let rest: ArchimateReaderExtra | undefined;
		if (typeNameOrOptions === undefined) {
			rest = options;
		} else if (!isString(typeNameOrOptions)) {
			rest = typeNameOrOptions;
		} else {
			typeName = typeNameOrOptions;
			rest = options;
		}

		const reader = new Reader(assign({model: this, lax: true} satisfies ReaderOptions, rest));
		const rootHandler = reader.handler(typeName);

		return reader.fromXML(xmlStr, rootHandler);
	}

	toXML(element: ModdleElement, options?: WriterOptions): Promise<{xml: string | undefined}> {
		const writer = new Writer(options);

		return new Promise(function (resolve, reject) {
			try {
				const result = writer.toXML(element);

				return resolve({
					xml: result,
				});
			} catch (err) {
				return reject(err);
			}
		});
	}
}
